function initCarousel() {
  // Check if carousel is already initialized
  if ($('.carousel').hasClass('slick-initialized')) {
    $('.carousel').slick('unslick');
  }
  
  $('.carousel').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}

// Initialize on document ready
$(document).ready(function() {
  initCarousel();
});